export default __webpack_public_path__ + "static/media/2122 cutlery top.b0697ae4.png";